import { createFileRoute } from '@tanstack/react-router'
import { Loader2, TriangleAlert } from 'lucide-react'
import { ApiError } from '@/lib/api/client'
import { useOrgQuery } from '@/lib/hooks/useOrgQuery'
import { PolicyEditor, type Policy } from '@/components/admin/PolicyEditor'

export const Route = createFileRoute('/_app/org/policies/$id')({
  component: EditPolicyPage,
})

function EditPolicyPage() {
  const { id } = Route.useParams()

  const query = useOrgQuery<Policy>(['admin-policy', id], `/admin/policies/${id}`)

  if (query.isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="size-5 text-primary animate-spin" strokeWidth={1.5} />
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-muted-foreground">
            Loading policy
          </span>
        </div>
      </div>
    )
  }

  if (query.error) {
    const status = query.error instanceof ApiError ? query.error.status : 0
    const isNotFound = status === 404
    return (
      <div className="px-10 py-12">
        <div className="max-w-md mx-auto border border-border bg-card rounded-md p-8 text-center">
          <TriangleAlert className="size-5 text-destructive mx-auto mb-3" strokeWidth={1.5} />
          <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-muted-foreground mb-2">
            {isNotFound ? 'Not found' : 'Load failed'}
          </div>
          <p className="text-sm text-muted-foreground">
            {isNotFound
              ? 'This policy may have been deleted. Head back to the list to see what is currently live.'
              : 'Unable to load the policy. Try refreshing in a moment.'}
          </p>
        </div>
      </div>
    )
  }

  return <PolicyEditor policy={query.data} />
}
